// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1S2wK","fileBtn":"File_fileBtn__3KleM","closeBtn":"File_closeBtn__2upJG","fileSelected":"File_fileSelected__6iO_O","disabled":"File_disabled__2eDWR"};